<template>
  <div>
    <div class="bl-find-search1">
      <advertisement
        :option="identity == 'product' ? $config.advertisement.horizontal.productSeachList : $config.advertisement.horizontal.actorSeachList"
        :width="'100%'"></advertisement>
      <div v-if="subjectType === 'ACTOR'" class="actor-banner">
        <img
          src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/advertisement/fint-actor-banner.png"
          :width="'100%'" />
      </div>
      <div class="bl-find-search1Div">
        <div class="bl-find-search__block">
          <div class="bl-find-search__input">
            <el-input :placeholder="$t('finds.searchVisitor')" v-if="identity === 'person'"
              v-model="query.searchKeywords" ></el-input>
            <el-input :placeholder="$t('finds.searchProduct')" v-if="identity === 'product'"
              v-model="query.searchKeywords" ></el-input>
            <el-input :placeholder="$t('finds.searchActor')" v-if="identity === 'actor'" v-model="query.searchKeywords"
              ></el-input>
          </div>
          <div :loading="loading" class="bl-find-search__btn f-w-b" @click="searchList('keyword')">
            <span class="el-icon-search f-w-b" />
            {{ $t('common.search') }}
          </div>
        </div>
        <div :class="oWidth <= 750 ? '' : 'flex fsb'">

          <div class="bl-find-search__help">
            <template v-if="keywordList.pageList && keywordList.pageList.length > 0">
              <span style="color: rgba(0,0,0,0.45);">{{ $t('common.returnsApplication') }}：</span>
              <a v-for="item in keywordList.pageList" :key="item.id" @click="keywordClick(item)">{{ item.keyword }}</a>
              <i class="el-icon-refresh-left bl-find-search__refresh" v-if="pages2 > 1" @click="keywordRefresh()"></i>
            </template>
          </div>
          <div style="flex:none;margin: 0 20px; padding:10px 0;">
            <div class="bl-find-r-page1">
              <template v-if="identity == 'actor'">
                <label @click="changeSort(sort, 'EXHIBITOR_UNIQUE_VISITOR', 1)" class="v-sort-1"
                  :class="{ desc: sort == 'desc', asc: sort == 'asc' }"><span>{{ $t('finds.attention') }}</span><i
                    class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i></label>
                <label @click="changeSort(sort2, 'EXHIBITOR_ADVERTS_VIDEO', 2)" class="v-sort-1"
                  :class="{ desc: sort2 == 'desc', asc: sort2 == 'asc' }"><span>{{ $t('finds.video') }}</span><i
                    class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i></label>
                <label @click="changeSort(sort3, 'EXHIBITOR_INITIAL', 3)" class="v-sort-1"
                  :class="{ desc: sort3 == 'desc', asc: sort3 == 'asc' }"><span>{{ $t('finds.spell') }}</span><i
                    class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i></label>
              </template>
              <template v-if="identity == 'product'">
                <label @click="changeSort(sort, 'PRODUCT_PAGE_VIEW', 1)" class="v-sort-1"
                  :class="{ desc: sort == 'desc', asc: sort == 'asc' }"><span>{{ $t('finds.popularity') }}</span><i
                    class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i></label>
                <label @click="changeSort(sort2, 'PRODUCT_VIDEO_URL', 2)" class="v-sort-1"
                  :class="{ desc: sort2 == 'desc', asc: sort2 == 'asc' }"><span>{{ $t('finds.video') }}</span><i
                    class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i></label>
              </template>
              <span @click="screenChange" style="cursor: pointer;color: rgba(0,0,0,0.45);">
                <i class="m-l-0 iconfont iconshaixuan" :class="tagSearchStatus ? 'theme-color' : ''" />
                <span :class="tagSearchStatus ? 'theme-color' : ''">{{ $t('筛 选') }}</span>
              </span>
            </div>
          </div>
        </div>

      </div>
      <template v-if="tagSearchStatus">
        <div class="ClickShai"></div>
        <div class="bl-find-condition">
          <div class="bl-find-condition__head">
            <div class="bl-container" v-loading="loading2">
              <div class="tag-search-block">
                <TagSearch v-if="questionSite.questionList && questionSite.questionList.length > 0"
                  :questionSite="questionSite" :questionListValue.sync="questionListValue"
                  @searchList="searchList('find')" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="bl-find-r-page2 flex fs " v-if="identity == 'actor'">
        <div v-for="item in $config.HALL_LIST" :key="item.name" class="hall mr6 mb15 font-size-13 pointer"
          :class="{ 'activeHall': item.id == exhibitionFloor }" @click="searchFloor(item.id)">
          {{ language == 'en' ? item.name : item.cnName }}
        </div>
      </div>
    </div>

    <div>
      <div class="bl-find-list" ref="result-list">
        <div class="bl-container" v-loading="loading" style="min-height: 300px">
          <el-row class="ShangWai" :gutter="30">
            <template v-if="identity == 'actor'">
              <el-col class="ShangList ShangList1" :span="8" v-for="(item, index) in dataList" :key="item.visitorId">
                <ExhibitorCard @collect="collectEvent_a" @invite="inviteEvent_a" @details="detailsEvent"
                  @msg="message_a" @live="live_a" :vData="item" :index="index"></ExhibitorCard>
              </el-col>
            </template>
            <template v-else-if="identity == 'product'">
              <el-col class="ShangList" :xs="6" :sm="6" :md="6" v-for="(item, index) in dataList" :key="item.visitorId">
                <ExhibitCard @callback="vExibitsCallback" :vData="item" :index="index" v-if="identity === 'product'" />
              </el-col>
            </template>
            <template v-else>
              <el-col :xs="8" :sm="8" :md="8" v-for="(item, index) in dataList" :key="item.visitorId">
                <VisitorCard showType="find" :index="index" :vData="item" @collect="collectEvent_p"
                  @invite="inviteEvent" @details="detailsEvent" @msg="msgEvent" v-if="identity == 'person'" />
              </el-col>
            </template>
          </el-row>
          <hNoData v-if="dataList.length == 0"></hNoData>
        </div>
        <div class="bl-container">
          <el-pagination v-if="dataList.length > 0" background @current-change="handleCurrentChange"
            :page-size="query.pageRows" :current-page.sync="query.pageNum" layout="total, prev, pager, next, jumper"
            :total="query.total" class="bl-page">
          </el-pagination>
        </div>
        <advertisement class="bl-container margin-t-24"
          :option="identity == 'product' ? $config.advertisement.horizontal.productBottom : $config.advertisement.horizontal.actorBottom"
          :width="'100%'" :height="'190px'"></advertisement>
      </div>
    </div>
    <div v-if="subjectType != 'ACTOR'">
      <advertisementVertical
        :option="identity == 'product' ? $config.advertisement.leftList.productFindlist : $config.advertisement.leftList.actorFindlist"
        :leftPosition='true' :top="advertisementTop+'px'"></advertisementVertical>
      <advertisementVertical
        :option="identity == 'product' ? $config.advertisement.rightList.productFindlist : $config.advertisement.rightList.actorFindlist"
        :rightPosition='true' :top="advertisementTop+'px'"></advertisementVertical>
    </div>

    <ChatWithExhibitor @invite="submitInvite" :action="action" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { scrollToY } from '@/utils/function.js'
// getExhibitorSearchList
import { getRecommendedVisitorList, getSearchTrendInfo, searchVisitorList, recommendProductList, getRecommendedExhibitorsList } from '@/api/find'
import { getProductTags } from '@/api/index'
import { eventMixin } from '@/mixins/event.js'
import commonMixin from '@/mixins/common.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import hNoData from '@/components/hNoData'
import TagSearch from '@/components/TagSearch'
import VisitorCard from '@/components/card/VisitorCard'
import ExhibitCard from '@/components/card/ExhibitCard'
import ExhibitorCard from '@/components/card/ExhibitorCard.vue'
import advertisement from '@/components/advertisement'
import advertisementVertical from '@/components/advertisementVertical'

export default {
  name: 'findList',
  mixins: [eventMixin, inviteMixin, commonMixin],
  components: {
    VisitorCard,
    ExhibitCard,
    ExhibitorCard,
    hNoData,
    advertisement,
    advertisementVertical,
    TagSearch
  },
  data() {
    return {
      isShow: false,
      advertisementLeft:'',
      advertisementRight:'',
      advertisementTop: 120,
      sort: '',
      sort2: '',
      sort3: '', // A-Z 排序
      sortField: 'recommend_custom_letter_asc',
      loading: false,
      loading2: false,
      kQuery: {
        pageNum: 1,
        pageRows: 8,
        total: 0
      },
      query: {
        pageNum: 1,
        pageRows: this.$route.params.type == 'actor' ? 18 : this.$route.params.type == 'product' ? 24 : 9,
        total: 0,
        searchKeywords: ''
      },
      questionListValue: [],
      dataList: [],
      questionSite: {},
      keywordList: {},
      listType: 'list',
      identity: this.$route.params.type || 'person',
      tagSearchStatus: false, // 筛选组件 显示隐藏
      exhibitionFloor: '', // 展馆
      oWidth: document.body.clientWidth,
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'subjectType', 'language']),
    pages: function() {
      if (this.query.total == 0) return 0
      let y = this.query.total % this.query.pageRows
      if (y == 0) {
        return this.query.total / this.query.pageRows
      } else {
        return parseInt(this.query.total / this.query.pageRows) + 1
      }
    },
    pages2: function() {
      if (this.kQuery.total == 0) return 0
      let y = this.kQuery.total % this.kQuery.pageRows
      if (y == 0) {
        return this.kQuery.total / this.kQuery.pageRows
      } else {
        return parseInt(this.kQuery.total / this.kQuery.pageRows) + 1
      }
    },
    ...{
      iType: function() {
        if (this.identity == 'person') return 'VISITOR'
        if (this.identity == 'product') return 'PRODUCT'
        if (this.identity == 'actor') return 'ACTOR'
      }
    }
  },
  mounted() {
    if(document.body.clientWidth > 750){
      this.isShow = true
    }
    window.PC.$RangersEventList('view')
    this.pageInit()
    
    
    console.log('进入list页面',typeof this.$route.query.type)
  },
  beforeDestroy() {
    sessionStorage.removeItem('findListActor')
  },
  methods: {
    // 点击弹出筛选
    shaiXuan() {
      this.isShow = !this.isShow
    },
    pageInit() {
      this.getProductTags()
      if (this.$route.query.keywords) {
        this.query.searchKeywords = this.$route.query.keywords
      }
      if (this.$route.query.type) {
        var list = JSON.parse(this.$route.query.type)
        this.fetchDataList(list)
      } else {
        this.fetchDataList()
      }
      
      this.getSearchTrendInfo()
    },
    // 展品卡片回调
    vExibitsCallback(eData) {
      switch (eData.type) {
        case 'message':
          this.message_a(eData.data)
          break
        case 'invite':
          if (eData.data.invite) return
          this.inviteEventExh(eData.data, eData.index, 'products')
          break
        case 'details':
          this.detailsEvent(eData.data)
          break
        case 'collect':
          this.collectEvent(
            {
              id: eData.data.collectionId,
              deleted: eData.data.collected,
              collectionSubjectType: this.iType,
              collectionSubjectId: eData.data.id
            },
            eData.index
          )
          break
        case 'live':
          this.live_a(eData.data)
          break
      }
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
    },
    // 页码 change
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.fetchDataList()
      this.$funcs.scrollToY(0, 10)
    },
    // 获取客商列表
    fetchVisitorList(questionList = []) {
      getRecommendedVisitorList({
        ...this.query,
        questionList,
        exhibitorId: this.exhibitorId,
        showType: 'PERSON_LIST'
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取展品列表
    fetchProductList(questionList) {
      recommendProductList({
        ...this.query,
        questionList,
        showType: 'PRODUCT_LIST',
        productSort: this.sortField
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.data) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []
            if (this.listType === 'search') {
              this.$nextTick(() => {
                scrollToY(this.$refs['result-list'].offsetTop - 178, '', 'easeOutSine')
              })
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取展商列表
    fetchActorList(questionList) {
      let tagIds = sessionStorage.getItem('findListActor') || ''
      getRecommendedExhibitorsList({
        ...this.query,
        tagIds,
        questionList,
        showType: 'ACTOR_LIST',
        exhibitionFloor: this.exhibitionFloor,
        exhibitorSort: this.sortField
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []

            if (this.listType === 'search') {
              this.$nextTick(() => {
                scrollToY(this.$refs['result-list'].offsetTop - 178, '', 'easeOutSine')
              })
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取列表
    fetchDataList(questionList) {
      if (this.listType == 'search' && this.identity == 'person') {
        this.searchList('search')
        return false
      }
      this.loading = true
      questionList = questionList || this.questionListValue
      switch (this.identity) {
        case 'person':
          this.fetchVisitorList(questionList)
          break
        case 'product':
          this.fetchProductList(questionList)
          break
        case 'actor':
          this.fetchActorList(questionList)
          break
      }
    },
    // 搜索
    searchList(type) {
      this.loading = true
      this.listType = 'search'
      let questionList = this.questionListValue
      if (type === 'keyword') {
        window.PC.$RangersEventList(type, this.query.searchKeywords)
      }
      if (type === 'find') {
        window.PC.$RangersEventList(type, questionList)
      }
      if (type != 'search') {
        this.kQuery.pageNum = 1
        this.query.pageNum = 1
      }

      switch (this.identity) {
        case 'person':
          // 搜索客商
          searchVisitorList({
            ...this.query,
            questionList,
            showType: 'PERSON_LIST'
          })
            .then(res => {
              return res.data
            })
            .then(res => {
              if (res.code == 1000) {
                let data = res.data
                this.query.total = data.total || 0
                this.query.pages = data.pages || 0
                this.dataList = data.list || []
              }
            })
            .finally(() => {
              this.loading = false
            })
          break
        default:
          // 搜索 展品/展商
          this.fetchDataList(questionList)
          break
      }
    },
    // 获取标签列表
    getProductTags() {
      let showType = ''
      switch (this.identity) {
        // 客商列表
        case 'person':
          showType = 'PERSON_LIST'
          break
        // 展品列表
        case 'product':
          showType = 'PRODUCT_LIST'
          break
        // 展商列表
        case 'actor':
          showType = 'ACTOR_LIST'
          break
      }

      this.loading2 = true

      getProductTags({
        showType
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.questionSite = res.data
          }
        })
        .finally(() => {
          this.loading2 = false
        })
    },
    // 关键词接口
    getSearchTrendInfo() {
      getSearchTrendInfo({ ...this.kQuery })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.keywordList = res.data
            this.kQuery.total = res.data.totalCount
          }
        })
    },
    // 关键词点击
    keywordClick(data) {
      this.query.searchKeywords = data.keyword
    },
    // 关键词刷新
    keywordRefresh() {
      let n = this.kQuery.pageNum
      let status = 'plus'
      // 加
      if (n == 1) {
        status = 'plus'
      }
      // 减
      if (n == this.pages2) {
        status = 'reduce'
      }
      if (status == 'plus') {
        n += 1
      } else {
        n -= 1
      }
      this.kQuery.pageNum = n
      this.getSearchTrendInfo()
    },
    // 找客商 收藏
    collectEvent_p(params, index, data) {
      params.collectionSubjectId = data.visitorId || data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
    // 找展商 收藏
    collectEvent_a(params, index, data) {
      params.collectionSubjectId = data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
    // 找展商 邀约
    inviteEvent_a(params, index, data) {
      data.exhibitorId = data.id
      data.exhibitorName = data.exhibitorName || data.name || data.atrName
      this.inviteEventExh(data, index, 'exhibitors')
    },
    // 找展商, 展品 消息
    message_a(data) {
      if (!data.exhibitorId) {
        data.exhibitorId = data.id
      }
      data.atrName = data.atrName || data.exhibitorName || data.name
      this.msgEventExh(data, null, this.identity === 'actor' ? 'exhibitors' : 'products')
    },
    // 找展商 直播
    live_a(data) {
      switch (this.identity) {
        // 展品
        case 'product':
          this.liveEvent(data.liveId)
          break
        // 展商
        case 'actor':
          this.liveEvent(data.liveId)
          break
      }
    },
    // 找客商 消息
    msgEvent(data, index) {
      console.log(data,'data')
      data.id = data.visitorId || data.id
      data.psjName = data.visitorName
      data.psjRank = data.post
      data.psjComName = data.corporateName
      data.headPortrait = data.headImage
      this.msgEventPerson(data, index)
    },
    // 找客商 详情
    detailsEvent(data) {
      this.pageDetail(data, this.identity)
    },
    // 向前翻译
    pagePrev() {
      if (this.query.pageNum == 1) return
      this.query.pageNum -= 1
      this.fetchDataList()
    },
    // 向后翻页
    pageNext() {
      if (this.query.pageNum == this.pages) return
      this.query.pageNum += 1
      this.fetchDataList()
    },
    changeSort(sort, field, level) {
      window.PC.$RangersEventList('sort', field)
      const sortName = 'sort' + (level == 1 ? '' : level)
      switch (sort) {
        case 'desc':
          this[sortName] = 'asc'
          this.sortField = field + '_ASC'
          break
        case '':
          this[sortName] = 'desc'
          this.sortField = field + '_DESC'
          break
        case 'asc':
          this[sortName] = ''
          this.sortField = 'recommend_custom_letter_asc'
          break
      }
      switch(level) {
        case 1:
          this.sort2 = ''
          this.sort3 = ''
          break
        case 2:
          this.sort = ''
          this.sort3 = ''    
          break
        case 3:
          this.sort = ''
          this.sort2 = ''
          break
      }
      
      this.searchList()
    },
    // 筛选
    screenChange() {
      this.tagSearchStatus = !this.tagSearchStatus
    },
    // 选中展馆
    searchFloor(id) {
      if (this.exhibitionFloor === id) {
        this.exhibitionFloor = ''
      } else {
        this.exhibitionFloor = id
      }
      this.searchList()
    }
  }
}
</script>

<style lang="stylus" scoped>
// @import './../styles/pages/searchList'


.tag-search-block {
  min-height: 116px;
}

.bl-find-search1 {
  position: relative;
  width: 100%;
  background: $color-white;

  .bl-find-search1Div {
    position: relative;
    margin: 0 auto;
    width: 1366px;
    padding:0 20px;

    .bl-find-search__block {
      margin: 32px auto 0;
      width: 100%;
      max-width: 1366px;

      .bl-find-search__input {
        // padding-right: 100px;
        width: 100%;
        overflow: hidden;

        & >>> .el-input__inner {
          height: 60px;
          line-height: 60px;
          border:none;
          background: rgba(0,0,0,0.05);
          border-radius: 8px;
          padding-right: 140px;
        }
      }

      .bl-find-search__btn {
        position: absolute;
        width: 140px;
        height: 60px;
        border-radius: 0;
        right: 20px;
        top: 0px;
        // background-color: $color-main;
        // border-color: $color-main;
        text-align: center;
        line-height:60px;
        color: $color-main;
        cursor: pointer;
      }
    }

    .bl-find-search__help {
      margin: 0 auto;
      padding: 8px 0;
      width: 100%;
      max-width: 1366px;
      min-height: 40px;

      * {
        line-height: 20px;
        font-size: 14px;
      }

      a {
        margin-right: 10px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .bl-find-search__refresh {
        cursor: pointer;
        display: inline-block;
        margin-top: 4px;
      }
    }
  }
}

.bl-find-condition {
  padding: 0 0 20px 0;
  background-color: $color-white;
  line-height: 24px;
}

.bl-table + .bl-find-r-page1 {
  margin-top: 20px;
}

.bl-find-r-page1 {
  font-size: 14px;
  overflow: hidden;

  * {
    line-height: 20px;
  }

  .page-acount {
    float: left;

    span {
      margin: 0 5px;
      font-size: 16px;
    }
  }

  .page-go {
    float: left;
    margin-left: 15px;

    span {
      margin: 0 8px;

      font {
        margin: 0 5px;
      }
    }

    i {
      cursor: pointer;

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}

.bl-find-list {
  padding-top: 24px;
  padding-bottom: 40px;
  min-height: 280px;

  .v-exhibits-card {
    margin-bottom: 25px;
  }

  .v-exhibitor-card {
    margin-bottom: 25px;
  }
}

.v-sort-1 {
  position: relative;
  margin-right: 16px;
  padding: 2px 8px;
  float: left;
  // border: 1px solid $border-color;
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
  user-select: none;

  * {
    line-height: 16px;
  }

  span {
    margin-right: 15px;
    color: rgba(0, 0, 0, 0.45);

  }

  i {
    position: absolute;
    right: 4px;
    top: 50%;
    color: $color-black-25;

    &.el-icon-caret-top {
      margin-top: -11px;
    }

    &.el-icon-caret-bottom {
      margin-top: -4px;
    }
  }

  &:hover {
    color: $color-main;
    border-color: $color-main;
  }

  &.asc {
    i.el-icon-caret-top {
      color: $color-main;
    }
  }

  &.desc {
    i.el-icon-caret-bottom {
      color: $color-main;
    }
  }
}


.hall {
    width: 98px;
    height: 33px;
    border-radius: 4px;
    text-align: center;
    line-height: 33px;
    border: 1px solid $color-main;
    color:$color-main;
}

.bl-find-r-page2{
  width: 1366px;
  padding:0 20px 12px 20px;
  margin: 10px auto;
}
.activeHall {
    color:$color-white;
    border: 1px solid $color-main;
    background:$color-main;
}

.tipWord {
    float: left;
    margin-left: 20px;
    line-height: 22px;
    color: $color-main;
    font-weight: bold;
}

.actor-banner {
    // padding: 74px 0;
    // min-height: 162px;
    // background: url('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/advertisement/fint-person-banner.png') no-repeat center;
    // background-size: cover;
}
</style>
